var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9414 17.058L14.5647 13.6812C15.7572 12.2611 16.3554 10.4354 16.2346 8.58495C16.1139 6.73448 15.2834 5.00207 13.9164 3.74899C12.5495 2.4959 10.7515 1.81888 8.89755 1.85912C7.04358 1.89935 5.2767 2.65373 3.96538 3.96493C2.65406 5.27614 1.89953 7.04294 1.85913 8.89691C1.81873 10.7509 2.49559 12.5489 3.74856 13.9159C5.00152 15.283 6.73386 16.1136 8.58432 16.2346C10.4348 16.3555 12.2605 15.7575 13.6807 14.5651L17.0575 17.9419C17.1748 18.0591 17.3337 18.125 17.4995 18.125C17.6653 18.125 17.8242 18.0591 17.9414 17.9419C18.0587 17.8247 18.1245 17.6657 18.1245 17.5C18.1245 17.3342 18.0587 17.1752 17.9414 17.058ZM3.12496 9.0624C3.12496 7.88807 3.47319 6.74012 4.12561 5.7637C4.77803 4.78729 5.70534 4.02626 6.79028 3.57687C7.87522 3.12747 9.06905 3.00989 10.2208 3.23899C11.3726 3.46809 12.4305 4.03358 13.2609 4.86396C14.0913 5.69433 14.6568 6.75229 14.8859 7.90405C15.115 9.05581 14.9974 10.2496 14.548 11.3346C14.0986 12.4195 13.3376 13.3468 12.3612 13.9992C11.3847 14.6517 10.2368 14.9999 9.06246 14.9999C7.48829 14.9981 5.97909 14.372 4.86598 13.2589C3.75287 12.1458 3.12674 10.6366 3.12496 9.0624Z",
    fill: "#AEAEB2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.39a2172e7190775625b0d2547d6413d4.svg";
export { ForwardRef as ReactComponent };